<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <FormKit
        type="radio"
        name="client_type"
        :options="[
          {
            label: 'Som klient',
            value: true,
          },
          {
            label: 'Nie som klient',
            value: false,
          },
        ]"
      />
    </div>
  </div>
</template>
